import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import { storageHelper } from "lib/helpers";

import { OperatorProductLakeList } from "./operator/features";
import { ProviderProductLakesList } from "./provider/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const ProductLakeList = () => {
  const currentUserRole = storageHelper.get("userRole");
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorProductLakeList />;
    }
    if (role === provider) {
      return <ProviderProductLakesList />;
    }
    return null;
  };

  const OrderListComponent = getComponent(currentUserRole);
  return OrderListComponent;
};

export default ProductLakeList;
